import Journeys from '@/pages/journeys';
import { createFileRoute } from '@tanstack/react-router';

// The embedded app serves every transactional overview tab here. A tab that migrates adds its own
// forward to the canonical `/transactional/:id/overview` URL while its rollout flag is on.
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview',
)({
  component: Journeys,
});
